export const deviceData = {
  total: 2,
  data: [
    {
      id: 9,
      name: 'Example Device',
      displayName: 'Example Device',
      type: 'App',
      vendorName: 'Example vendor name',
      itemNumber: 'Example item number',
      deviceDescription: 'Example device description',
      createdAt: '2021-09-23T10:52:31.476Z',
      updatedAt: '2021-09-23T10:52:31.476Z',
      createdBy: 1,
      updatedBy: 1,
    },
    {
      id: 8,
      name: 'Test name',
      displayName: 'Test name',
      type: 'App',
      vendorName: null,
      itemNumber: 'Test item number',
      deviceDescription: null,
      createdAt: '2021-09-23T10:43:51.635Z',
      updatedAt: '2021-09-23T10:59:16.222Z',
      createdBy: 1,
      updatedBy: 1,
    },
  ],
};
